<template lang="html">
  <v-card >
    <v-footer
      color="red"
      v-bind="localAttrs"
      :padless="padless"
    >
         <cookie-law theme="mytheme" storageName="imemo:accepted" storageType="cookies" buttonText="Accept" v-on:accept="CookiesAllow()" v-on:decline="CookiesAllow()" buttonDecline=true>
           <div slot="message">
           Imemo uses cookies to get list appoval data, you agree to our Privacy policy and use of cookies.
          </div>
         </cookie-law>
    </v-footer>

  </v-card>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default{
    name:"CookieCard",
    components: { CookieLaw },
    data: () => ({
      padless: true,
      variant: 'fixed',
    }),
     computed: {
      localAttrs () {
        const attrs = {}
        if (this.variant === 'default') {
          attrs.absolute = false
          attrs.fixed = false
        } else {
          attrs[this.variant] = true
        }
        return attrs
      },
    },
      methods: {
        CookiesAllow(){
            //- alert("cookies allow")
        }
      }
}
</script>
<style scoped>
.Cookie--mytheme {
    background: #D42A2A;
    color: white;
    padding:1.250em;
}



</style>
